import { Box } from '@mui/material';
import {
  FC, useContext, useEffect, useState,
} from 'react';
import { Outlet } from 'react-router-dom';

import SwitchShop from 'containers/SwitchShop';
import { PaymentProvider } from 'context/PaymentContext';
import { SystemContext } from 'context/SystemContext';
import { UserContext } from 'context/UserContext';
import { UserLocationAccessContext } from 'context/UserLocationAccessContext';
import { Root } from 'layouts/ManagementLayout/index.styled';
import ManagementNavbar from 'layouts/ManagementLayout/Navbar';

import { adminDetailsIncomplete } from 'utils/clientUtils';

const ManagementLayout:FC = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSwitchShop, setShowSwitchShop] = useState(false);
  const { user, userInfo } = useContext(UserContext);
  const { shopSettings, clientInfo } = useContext(SystemContext);
  const { shopOptions, isLoading: loadingStores } = useContext(UserLocationAccessContext);

  useEffect(() => {
    if (adminDetailsIncomplete(user, userInfo, shopSettings) && !showLogin) {
      setShowLogin(true);
    }
  }, [user?.isAnonymous, shopSettings, userInfo?.userType, showLogin]);

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <ManagementNavbar clientInfo={clientInfo} />
      <Root>
        <PaymentProvider>
          <Outlet />
        </PaymentProvider>
      </Root>

      {showSwitchShop && (
        <SwitchShop
          onClose={() => setShowSwitchShop(false)}
          shopOptions={shopOptions}
          isLoading={loadingStores}
        />
      )}
    </Box>
  );
};

export default ManagementLayout;
